import React from 'react';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';

import Icon from '../../atoms/icon';

interface TriageRefreshBannerProps {
  isVisible: boolean;
  className?: string;
}

/**
 * Displays a warning banner while triage refresh is in progress.
 *
 * @prop isVisible whether the banner should be shown
 * @prop className optional class names to append
 * @returns triage refresh warning banner when visible
 */
const TriageRefreshBanner: React.FC<TriageRefreshBannerProps> = ({
  isVisible,
  className
}): JSX.Element => {
  if (!isVisible) {
    return null;
  }
  const classes = className
    ? `bg-light-orange pa-3 mb-4 ${className}`
    : 'bg-light-orange pa-3 mb-4';
  return (
    <div className={classes}>
      <Icon icon={faTriangleExclamation} className="mr-2" />
      Another user is refreshing triage data. You are viewing the latest
      available snapshot. Please refresh again in a few minutes for the newest
      results.
    </div>
  );
};

export default TriageRefreshBanner;
